import { MyAccount } from "./MyAccount";
import AccountDetails from "./AccountDetails";
export { AccountDetails };
export default MyAccount;
